import '../../styles/templates/page.scss';
import { docReady } from '../helpers/docReady';
docReady(() => {
    // console.log('Page Template');
});
